import React, { useState, useEffect } from "react"
import { Erroralert, Successalert } from "../Components/popups";
import Loadingspinner from "../Components/loading";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Universalpageheader from "../Headers/universalpageheader";
import Searchbar from "../Components/searchbar";

const Profilesettings = () => {
    const subProducts = useSelector((state) => state.subProducts.data);
    const { user, loggedIn } = useSelector((state) => state.user);

    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');
    const [loading, setloading] = useState(false)
    const [showsearchbar, setshowsearchbar] = useState(false);

    const [profileurl, setprofileurl] = useState(user?.profileurl);
    const [username, setusername] = useState(user?.fullName);
    const [email, setemail] = useState(user?.email);
    const [phone, setphone] = useState(user?.mobileNumber);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);




    const saveuserdetails = (event) => {
        seterror(null)
        setloading(true)
        event.preventDefault();
        axios.post('', {
            username: username,
            email: email,
            phone: phone,
        }).then(function (response) {
            setloading(false)
            if (!response.data.error) {
                setsuccess('Details updated successfully')
                setTimeout(() => {//navigate user after 2 seconds of display
                    // setsessionuser(response.data)
                    // axios.defaults.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + response.data?.token }
                    // window.location.reload();
                }, 2000);
            } else {
                seterror(response.data.message)
            }
        }).catch(function (error) {
            setloading(false)
            seterror("there was an error try again later")
        });

    }



    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Account Details"} withbackicon={true} />
            {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
            {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
            {loading && <Loadingspinner />}
            <div style={{ padding: "5%" }}>
                <div className="wrapimagechange">
                    <div>
                        <img className="imageavatar" src={profileurl || require('./../../assets/common/avatar.png')} alt="Profile" />
                    </div>
                </div>
                <Box component="form" onSubmit={saveuserdetails} noValidate sx={{ mt: 1 }}>
                    <div className="wrapprofile">
                        <div className="profileleft">
                            <div>Email</div>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                value={email}
                                onChange={(e) => setemail(e.target.value)}
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                            /><br />
                            <div>Phone</div>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="phone"
                                value={phone}
                                onChange={(e) => setphone(e.target.value)}
                                label="Phone Number"
                                name="email"
                                autoComplete="tel"
                            />
                        </div>
                        <div className="profileright">
                            <div>Username</div>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                value={username}
                                onChange={(e) => setusername(e.target.value)}
                                id="username"
                                label="Full name"
                                name="username"
                            />
                        </div>
                    </div>
                    <br />
                    <Button type="submit" variant="contained">Save Changes</Button>
                </Box>

                <br /> <br />
            </div>
        </div>
    )
}
export default Profilesettings